import { type WorkerRequirement } from "@src/appV2/redesign/Documents/api/types";

const NUMBER_BLOCKING_REQUIREMENTS_TO_GROUP_CARDS = 3;

interface ShouldGroupBlockingRequirementCardsProps {
  inReviewVisibleBlockingRequirements: WorkerRequirement[];
  notInReviewVisibleBlockingRequirements: WorkerRequirement[];
}

export function shouldGroupBlockingRequirementCards(
  props: ShouldGroupBlockingRequirementCardsProps
) {
  const { inReviewVisibleBlockingRequirements, notInReviewVisibleBlockingRequirements } = props;

  return (
    (notInReviewVisibleBlockingRequirements.length === 0
      ? inReviewVisibleBlockingRequirements.length
      : notInReviewVisibleBlockingRequirements.length) >=
    NUMBER_BLOCKING_REQUIREMENTS_TO_GROUP_CARDS
  );
}
